import React, { useEffect, useRef } from "react";
import RightArrow from '../assets/images/icn-arrow-right-red.png';

const FeatureSectionBlock = ({ data }) => {
  const relatedLinksRef = useRef(null);

  let feature = data.primary;
  let featureItems = data.items;

  useEffect(() => {
    if (relatedLinksRef.current && featureItems && featureItems.length > 0) {
      // Get all related link blocks
      const blocks = relatedLinksRef.current.querySelectorAll('.relatedLinkBlock');
      let maxWidth = 0;

      // Temporarily set width to auto to measure natural width
      blocks.forEach(block => {
        block.style.width = 'auto';
        block.style.maxWidth = 'none';
        const blockWidth = block.offsetWidth;
        if (blockWidth > maxWidth) {
          maxWidth = blockWidth;
        }
      });

      // Set the CSS custom property for the max width
      relatedLinksRef.current.style.setProperty('--max-block-width', `${maxWidth}px`);

      // Reset styles to let CSS take over
      blocks.forEach(block => {
        block.style.width = '';
        block.style.maxWidth = '';
      });
    }
  }, [featureItems]);

  return (
    <React.Fragment>
      <section className="featureBlockSection">

        {/* MAIN FEATURE BLOCK */}
        <div className="mainFeatureWrapper">
          <img src={feature.feature_main_image.url} alt={feature.feature_main_image.alt} />
          <div className="mainFeatureContent">
            <img className="mainFeatureIcon" src={feature.feature_main_icon.url} alt={feature.feature_main_icon.alt} />
            <div className="mainFeatureHeader">
              <h2>{feature.feature_main_header.text}</h2>
            </div>
            <div className="featureDescription">
              <p>{feature.feature_main_description.text}</p>
            </div>
            <div className="featureLink">
              <a className="featureLinkButton" href={feature.feature_main_link.url ? feature.feature_main_link.url : '#'}>
                {feature.feature_main_link_text}
                <span>
                  <img src={RightArrow} alt="Arrow Right" width="24" height="16" />
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* SECONDARY FEATURES */}

        {/* BLOCK 1 */}
        <div className="secondaryFeatureBlock block1">
          <div className="secondaryFeatureIconWrapper">
            <img className="secondaryFeatureIcon" src={feature.feature_secondary_icon_1.url} alt={feature.feature_secondary_icon_1.alt} height="30" width="30" />
          </div>
          <div className="secondaryFeatureHeader">
            <h3>{feature.feature_secondary_header_1.text}</h3>
          </div>
          <div className="secondaryFeatureDescription">
            <p>{feature.feature_secondary_description_1.text}</p>
          </div>
          <div className="featureLink secondary">
            <a className="featureLinkButton" href={feature.feature_secondary_link_1.url ? feature.feature_secondary_link_1.url : '#'}>
              {feature.feature_secondary_link_text_1}
              <span>
                <img src={RightArrow} alt="Arrow Right" width="24" height="16" />
              </span>
            </a>
          </div>
        </div>

        {/* BLOCK 2 */}
        <div className="secondaryFeatureBlock block2">
          <div className="secondaryFeatureIconWrapper">
            <img className="secondaryFeatureIcon" src={feature.feature_secondary_icon_2.url} alt={feature.feature_secondary_icon_2.alt} height="30" width="30" />
          </div>
          <div className="secondaryFeatureHeader">
            <h3>{feature.feature_secondary_header_2.text}</h3>
          </div>
          <div className="secondaryFeatureDescription">
            <p>{feature.feature_secondary_description_2.text}</p>
          </div>
          <div className="featureLink secondary">
            <a className="featureLinkButton" href={feature.feature_secondary_link_2.url ? feature.feature_secondary_link_2.url : '#'}>
              {feature.feature_secondary_link_text_2}
              <span>
                <img src={RightArrow} alt="Arrow Right" width="24" height="16" />
              </span>
            </a>
          </div>
        </div>

        {/* RELATED LINKS */}
        <div className="relatedLinksWrapper" ref={relatedLinksRef}>
          {featureItems && featureItems.map((item, i) => {
            return (
              <div className="relatedLinkBlock" key={i}>
                {item.feature_related_icon.url &&
                  <div className="relatedLinkIconWrapper">
                    <img className="relatedLinkIcon" src={item.feature_related_icon.url} alt={item.feature_related_icon.alt} height="40" width="30" />
                  </div>
                }
                <div className="relatedLinkContent">
                  <div className="relatedLinkItem">
                    <a href={item.feature_related_link.url ? item.feature_related_link.url : '#'}>
                      {item.feature_related_link_text}
                    </a>
                  </div>
                  <p>
                    {item.feature_related_description.text ? item.feature_related_description.text : ''}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

      </section>
    </React.Fragment >
  )

}

export default FeatureSectionBlock;